module.exports = __webpack_public_path__ + "img/Logo_corner_top_right.4f166629.jpg";